import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router';
import Pagination from '@mui/material/Pagination';
import moment from 'moment';
import MapComponent from '../MapComponent';
import useApi from '../../api/useApi';
// import Notification from '../../components/Notification';
import Notification from '../Notification';
import '../../scrollbar.css';

function RuleAlert({ deviceId, handleClose }) {
  const history = useHistory();
  const user = sessionStorage.getItem('user');
  const userId = user && JSON.parse(sessionStorage.user).user.id;
  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [{ isLoading, isError, data }, getRuleAlert] = useApi();
  const [markAsRead, setMarksRead] = useApi();
  const [selectedRow, selectRow] = useState([]);
  const [ruleData, setRuleData] = useState([]);
  const [changeAlert, setChangeAlert] = useApi();
  const [devices, setDevices] = useState([]);
  const [notification, setNotification] = useState(false);
  const [message, setMessage] = useState();
  const [formData, setFormData] = useState({ parameter: '', condition: '', deviceId, readBy: '', q: '' });
  const orgId = JSON.parse(sessionStorage.user).organization.id;
  const [pageCount, setpageCount] = useState(0);
  const [searchFlag, setSearchFlag] = useState(false);
  const [page, setPage] = useState(1);
  let itemsPerPage;
  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleChange = (event, value) => {
    setPage(value);
  };

  const searchData = () => {
    // setSearchFlag(true);
    getRuleAlert(`/organization/${orgId}/search?type=ruleAlert&searchItem=${formData.q}`, 'GET');
  };

  useEffect(() => {
    getRuleAlert(
      `/organization/${orgId}/ruleAlerts?limit=${itemsPerPage}&page=${page}&device=${formData.deviceId}&condition=${formData.condition}`,
      'GET'
    );
  }, []);

  useEffect(() => {
    getRuleAlert(
      `/organization/${orgId}/ruleAlerts?limit=${itemsPerPage}&page=${page}&device=${formData.deviceId}&condition=${formData.condition}`,
      'GET'
    );
  }, [page]);

  useEffect(() => {
    setRuleData([]);
    getRuleAlert(
      `/organization/${orgId}/ruleAlerts?limit=${itemsPerPage}&page=${page}&param=${formData.parameter}&device=${formData.deviceId}&condition=${formData.condition}`,
      'GET'
    );
  }, [formData.parameter, formData.condition, formData.deviceId]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setRuleData(data.ruleAlerts);

      data.devices && setDevices(data.devices);
      if (page === 1) {
        const total = Math.ceil(data.count / itemsPerPage);
        setpageCount(total);
      }
    }
  }, [isLoading, isError, data]);

  const getTimeoffset = (ts) => {
    // const _ts = Number(ts);
    const _date = new Date(ts);
    // const timeZoneOffset = _date.getTimezoneOffset();
    // const _timestamp = _date.getTime();
    // if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
    //   return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    // }

    // if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
    //   return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    // }

    // if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
    //   return `${Math.round(
    //     ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
    //   )} minutes ago`;
    // }

    // return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;
    return moment(_date).fromNow();
    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  const readAlert = (id) => {
    const body = {
      user: userId,
    };
    setChangeAlert(`/ruleAlert/${id}`, 'PATCH', body);
  };

  const markAllAsRead = () => {
    const body = {};
    setMarksRead(
      `/organization/${orgId}/ruleAlerts?param=${formData.parameter}&device=${formData.deviceId}&condition=${formData.condition}`,
      'PATCH',
      body
    );
  };

  return (
    <div>
      <div className="z-50 device_top">
        <div
          className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
          style={{ paddingTop: '4vh' }}
        >
          <span className="text-titleColor font-bold text-base">Notifications</span>

          <div className="block lg:flex mt-1 lg:mt-0 button_mobile">
            <button
              className="mt-1 mx-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
              onClick={() => handleClose()}
            >
              Back
              {/* <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" /> */}
            </button>
            <button
              className="mt-1 mx-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
              onClick={() => markAllAsRead()}
            >
              Mark all as Read
              {/* <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" /> */}
            </button>
            <button
              className="mt-1 mx-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
              onClick={() => {
                //  downloadExcel('tblData');
              }}
            >
              Report
              <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
            </button>
            <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl mobile_search">
              <input
                type="text"
                placeholder="Search"
                autoComplete="off"
                className="text-textBox bg-transparent focus:outline-none"
                value={formData.q}
                name="q"
                onChange={handleInputChange}
                style={{ borderColor: '#e6e6e6' }}
                onKeyDown={(e) => {
                  if (e.which === 13) searchData();
                }}
              />
              <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 button_search" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="tbl tbl1 mobile_view" style={{ minWidth: '700px' }}>
        <div className="bg-white w-tableWidth m-auto mb-3">
          <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
            <div className="px-8 py-1.5 flex w-full relative bg-primary text-white items-center">
              <div className="py-1 text-left text-xs w-1/3">
                {' '}
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none button_arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.deviceId}
                    name="deviceId"
                    className="border  font-bold sm:text-xs overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-2 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md button_table"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option className="button_row" value="">
                      DEVICE
                    </option>
                    {devices.length &&
                      devices.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="py-1 text-left text-xs w-1/3">
                {' '}
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none button_arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.parameter}
                    name="parameter"
                    className="border  font-bold sm:text-xs overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-2 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md button_table"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option className="button_row" value="">
                      PARAMETER
                    </option>
                    <option className="button_row" value="tor" id="tor">
                      Tor
                    </option>
                    <option className="button_row" value="vbat" id="vbat">
                      Battery
                    </option>
                    <option className="button_row" value="rssi" id="rssi">
                      RSSI
                    </option>
                    <option className="button_row" value="temperature" id="temperature">
                      Temperature
                    </option>
                    <option className="button_row" value="humidity" id="humidity">
                      Humidity
                    </option>
                    <option className="button_row" value="pressure" id="pressure">
                      Pressure
                    </option>
                    <option className="button_row" value="location" id="location">
                      Location
                    </option>
                  </select>
                </div>
              </div>
              <div className=" py-2.5 text-xs font-bold w-1/6">ALERT VALUE</div>
              {/* <div className="py-1 text-left text-xs w-1/3">
                    {' '}
                    <div className="relative inline-flex">
                      <svg
                        className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none button_arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 412 232"
                      >
                        <path
                          d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                          fill="#ffffff"
                          fillRule="nonzero"
                        />
                      </svg>
                      <select
                        value={formData.readBy}
                        name="readBy"
                        className="border  font-bold sm:text-xs overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-2 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md button_table"
                        onChange={handleInputChange}
                        style={{ borderColor: '#e6e6e6' }}
                      >
                     
                        <option className="button_row" value="">
                          READ BY
                        </option>
                      </select>
                    </div>
                  </div> */}
              <div className="py-1 text-center text-xs w-1/3">
                {' '}
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none button_arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.condition}
                    name="condition"
                    className="border  font-bold sm:text-xs overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-2 lg:pl-3 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md button_table"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                  >
                    <option className="fy-4">CONDITION</option>
                    <option key="isEqualTo" value="===" className="fy-4">
                      IsEqualTo
                    </option>
                    <option key="isNotEqualTo" value="!==" className="fy-4">
                      IsNotEqualTo
                    </option>
                    <option key="isLessThan" value="<" className="fy-4">
                      IsLessThan
                    </option>
                    <option key="isGreaterThan" value=">" className="fy-4">
                      IsGreaterThan
                    </option>
                    <option key="isGreaterThanEqualTo" value=">=" className="fy-4">
                      IsGreaterThanEqualTo
                    </option>
                    <option key="isLessThanEqualTo" value="<=" className="fy-4">
                      IsLessThanEqualTo
                    </option>
                  </select>
                </div>
              </div>
              <div className=" py-2.5 text-xs font-bold w-1/6">REF VALUE</div>
              <div className=" py-2.5 text-xs font-bold w-1/6">REPORTED AT</div>
              <div className=" py-2.5 text-xs font-bold w-1/6 text-center">READ BY</div>
            </div>
          </div>
          {!isLoading ? (
            <div className="hideScroll device_scroll" style={{ overflowY: 'scroll', height: '64vh' }}>
              <div className="w-full">
                {ruleData.length !== 0 &&
                  ruleData.map((x) => {
                    let deviceTypeIcon = x?.Device?.deviceType !== null ? x?.device?.deviceType : '';
                    if (x?.Device?.deviceType === 'BLE_TAG')
                      deviceTypeIcon = <img src="./assets/img/Bluetooth.svg" className="w-5 h-5" />;
                    if (x?.Device?.deviceType === 'CATM1_TAG')
                      deviceTypeIcon = <img src="./assets/img/Cellular.svg" className="w-5 h-5" />;
                    if (x?.Device?.deviceType === 'BLE_GW')
                      deviceTypeIcon = <img src="./assets/img/Gateway.svg" className="w-5 h-5" />;
                    return (
                      <div
                        className={`my-2 px-8 py-1 xl:py-1.5 items-center flex
                       relative hover:border-indigo-200 focus-within:border-indigo-200 ${
                         x.isActive && !selectedRow.includes(x.id) ? 'bg-rowSelect' : ''
                       }`}
                        style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                        onClick={() => {
                          selectRow((oldArray) => [...oldArray, x.id]);
                          readAlert(x.id);
                        }}
                      >
                        <div className="w-1/3 flex items-center text-role text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs phone_font">
                          {deviceTypeIcon}
                          <div className="py-2 ml-2 text-xs md:no-underline md:hover:underline text-primary font-semibold phone_font">
                            {x.deviceId}
                          </div>
                        </div>
                        <div className="py-1 text-left text-xs w-1/3">{x.parameter}</div>
                        <div className=" py-2.5 text-xs w-1/6">
                          {isNaN(x.alertValue) ? x.alertValue : parseFloat(x.alertValue)}
                        </div>
                        <div className="py-1 text-center text-xs w-1/3">{x.condition}</div>
                        <div className="py-1 text-left text-xs w-1/6">
                          {isNaN(x.value) ? x.value : parseFloat(x.value)}
                        </div>
                        {/* <div className="py-1 text-left text-xs w-1/3">{x.readBy}</div> */}
                        <div className=" py-2.5 text-xs w-1/6">{getTimeoffset(x.createdAt)}</div>
                        <div className=" py-2.5 text-xs w-1/6 text-center">
                          {x.reader || selectedRow.includes(x.id)
                            ? (x.reader && x.reader.userName) || (user && JSON.parse(sessionStorage.user).user.userName)
                            : '---'}
                        </div>
                      </div>
                    );
                  })}
                <div />
              </div>
            </div>
          ) : (
            <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
          )}
        </div>
      </div>
      <div className="block lg:flex mt-1 lg:mt-0 absolute bottom-2 right-2">
        <Pagination
          count={pageCount}
          page={page}
          onChange={handleChange}
          variant="outlined"
          shape="rounded"
          className="mt-4 ml-auto shadow-2xl"
          size="small"
        />
      </div>
    </div>
  );
}

export default RuleAlert;
